import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldComponent, FieldSet} from '@simpli/meta-schema'
import * as Component from '@simpli/vue-render-schema'
import {GithubUser} from '@/model/resource/GithubUser'

export class ListGithubUserSchema extends DefaultSchema {
  readonly name = 'ListGithubUser'

  readonly fieldSet: FieldSet<GithubUser> = {
    login: (): FieldComponent => ({
      is: Component.Render,
    }),
    avatarUrl: (schema): FieldComponent => ({
      is: Component.RenderImage,
      bind: {
        src: schema.model.avatarUrl,
        alt: this.translateFrom(schema.fieldName),
        innerClass: 'w-20 h-20',
      },
    }),
    url: (schema): FieldComponent => ({
      is: Component.RenderAnchor,
      bind: {
        href: schema.model.url,
        label: schema.model.url,
        target: '_blank',
      },
    }),
  }
}
